/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.templates.create.schedules.create.tickets.controllers', [
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.templates',
  'acme.common.service.ticketConfig'
])

.controller('TemplatesCreateSchedulesCreateTicketsController', ['$scope', '$state', '$timeout', 'ApiService', 'HelpersService', 'TemplatesService', 'TicketConfigService', 'PrinterData', function($scope, $state, $timeout, ApiService, HelpersService, TemplatesService, TicketConfigService, PrinterData) {

    $scope.templatesCreateSchedulesCreateTickets = {

      model: {},
      currentTicketConfig: {},
      tenantTicketConfig: {},

      ticketConfigs: [],
      printers: [],

      template: {},
      schedule: {},

      layoutLevels: TicketConfigService.getLayout('schedules'),

      hasValidTicketConfig: false,

      init: function() {
        this.template = TemplatesService.getModel();

        $scope.$on('TemplatesService::Update', this.onTemplatesServiceUpdate);
        $scope.$on('TemplatesCreateSchedulesCreateController::Save', this.onTemplatesCreateSchedulesCreateControllerSave);

        if ($state.params && $state.params.scheduleId) {
          this.schedule = TemplatesService.getScheduleById($state.params.scheduleId).schedule;
          if (this.schedule && TemplatesService.hasScheduleTicketConfig(this.schedule)) {
            this.currentTicketConfig = TemplatesService.getScheduleTicketConfig(this.schedule);
          }
        }else{
          this.schedule = TemplatesService.getNewSchedule().schedule;
        }

        if (PrinterData.data && PrinterData.data.success) {
          this.success.getPrinters(PrinterData);
        } else {
          this.error.getPrinters(PrinterData);
        }

        this.getTicketConfigs();
        this.getDefaultTicketConfig();
      },

      getTicketConfigs: function() {
        ApiService.tickets.list(HelpersService.getPaginator()).then(this.success.init, this.error.init);
      },

      getDefaultTicketConfig: function() {
        ApiService.themes.getTicketConfig().then(this.success.getDefaultTicketConfig, this.error.getDefaultTicketConfig);
      },

      getPrinters: function() {
        ApiService.tickets.printers.list().then(this.success.getPrinters, this.error.getPrinters);
      },


      hasTicketConfigs: function() {
        return (this.ticketConfigs.length > 0);
      },

      hasTicketConfig: function() {
        this.hasValidTicketConfig = (this.currentTicketConfig && this.currentTicketConfig.hasOwnProperty('printerConfigs') && this.currentTicketConfig.printerConfigs instanceof Array);
        return this.hasValidTicketConfig;
      },

      isCustomizedLayout: function() {
        var self = $scope.templatesCreateSchedulesCreateTickets,
            i, ii,
            r = false;

        for (i=0, ii=self.printers.length; i < ii; i++) {
          if (!self.isLayoutSelection(self.printers[i], 'settings')) {
            r = true;
            break;
          }
        }

        return r && self.currentTicketConfig && self.currentTicketConfig.name && self.currentTicketConfig.id;
      },

      findTicketConfig: function(id) {
        var i, ii,
          r = false;

        if (id) {
          for (i=0,ii=this.ticketConfigs.length;i<ii;i++) {
            if (this.ticketConfigs[i].id === id) {
              r = {
                index: i,
                ticketLayout: this.ticketConfigs[i]
              };
              break;
            }
          }
        }

        return r;
      },

      getDefaultConfigForPrinter: function(printer) {
        var r = '',
          printerName;
        if (this.tenantTicketConfig && printer && printer.name) {
          for (printerName in this.tenantTicketConfig) {
            if (this.tenantTicketConfig.hasOwnProperty(printerName) && printerName === printer.name) {
              r = this.tenantTicketConfig[printerName] || '';
              break;
            }
          }
        }

        return r;
      },

      getSettingsConfigForPrinter: function(printer) {
        var i, ii,
            j, jj,
            selection,
            ticketConfig,
            printerConfig,
            r = '';
        if (this.currentTicketConfig && this.currentTicketConfig.id) {
          ticketConfig = this.findTicketConfig(this.currentTicketConfig.id);

          if (ticketConfig && ticketConfig.ticketLayout &&
            (ticketConfig.ticketLayout.printerConfigs instanceof Array) &&
            ticketConfig.ticketLayout.printerConfigs.length) {

            for (i = 0, ii = ticketConfig.ticketLayout.printerConfigs.length; i < ii; i++) {
              printerConfig = ticketConfig.ticketLayout.printerConfigs[i];
              if( printerConfig.printerId && (printerConfig.printerId === printer.printerId) ) {

                selection = printerConfig.selection || this.layoutLevels[0].value;

                if (selection === this.layoutLevels[0].value) {
                  r = this.getDefaultConfigForPrinter(printer);
                } else {
                  r = printerConfig.config || '';
                }
                break;
              }
            }

          }

        }

        return r;
      },

      isLayoutSelection: function(printer, type) {
        return printer && printer.selection && type && (printer.selection === type);
      },

      processTicketConfigs: function(list) {
        var r = [],
            i, ii;

        for (i = 0, ii = list.length; i < ii; i++) {
          if (list[i].status && list[i].status.published) {
            r.push(list[i]);
          }
        }

        return r;
      },

      process: function(list) {
        var i, ii,
          printerConfig,
          printersList = [];
        list = list || [];
        for (i = 0, ii = list.length; i < ii; i++) {
          if ( list[i].printerId && list[i].enabled) {
            printerConfig = this.getConfigForPrinter(list[i]);
            list[i].config = printerConfig.config  || '';
            list[i].selection = printerConfig.selection  || this.layoutLevels[0].value;
            printersList.push(list[i]);
          }
        }
        if (printersList.length) {
          this.hasEnabledPrinters = true;
        }
        return printersList;
      },

      getConfigForPrinter: function(printer) {
        var i, ii,
          r = '',
          selection;
        if (this.currentTicketConfig && this.currentTicketConfig.id) {
          if (this.currentTicketConfig.printerConfigs instanceof Array && this.currentTicketConfig.printerConfigs.length) {
            for (i = 0, ii = this.currentTicketConfig.printerConfigs.length; i < ii; i++) {
              if( this.currentTicketConfig.printerConfigs[i].printerId && (this.currentTicketConfig.printerConfigs[i].printerId === printer.printerId) ) {
                selection = this.currentTicketConfig.printerConfigs[i].selection || this.layoutLevels[0].value;
                r = {
                  selection: selection,
                  config: (selection === this.layoutLevels[2].value) ? this.currentTicketConfig.printerConfigs[i].config : ''
                };
                break;
              }
            }
          }
        }

        return r;
      },

      ticketConfigChanged: function() {
        var self = $scope.templatesCreateSchedulesCreateTickets;

        if (self.printers instanceof Array) {
          self.printers.forEach(function(printer) {
            printer.selection = self.layoutLevels[1].value;
          });
        }
        self.adjustLayoutSelectionName();
      },

      adjustLayoutSelectionName: function() {
        if (this.currentTicketConfig && this.currentTicketConfig.name) {
          this.layoutLevels[1].name = this.currentTicketConfig.name;
        }
      },

      success: {
        init: function(response) {
          var self = $scope.templatesCreateSchedulesCreateTickets,
              ticketLayout;
          self.ticketConfigs = self.processTicketConfigs(response.data.payload.list);
          if (self.currentTicketConfig && self.currentTicketConfig.hasOwnProperty('id')) {
            if (!self.isCustomizedLayout()) {
              ticketLayout = self.findTicketConfig(self.currentTicketConfig.id);

              if (ticketLayout) {
                self.currentTicketConfig = self.ticketConfigs[ticketLayout.index];
              }
            }
          }
          self.adjustLayoutSelectionName();
        },
        getDefaultTicketConfig: function(response) {
          var self = $scope.templatesCreateSchedulesCreateTickets;
          self.tenantTicketConfig = response.data.payload.ticketConfig;
        },
        getPrinters: function(response) {
          var self = $scope.templatesCreateSchedulesCreateTickets;
          self.printers = self.process(response.data.payload);
        }
      },

      error: {
        init: function(response) {},
        getDefaultTicketConfig: function(response) {
          $scope.templatesCreateSchedulesCreateTickets.getPrinters();
        },
        getPrinters: function(response) {}
      },

      marshall: function() {
        var i, ii,
          model = {},
          data = [],
          config,
          name,
          r = null;

        if (this.currentTicketConfig) {
          for (i = 0, ii = this.printers.length; i < ii; i++) {
            // Send empty string to backend if it's not custom
            config = '';
            name = this.printers[i].name;
            if (this.isLayoutSelection(this.printers[i], 'custom') && this.printers[i].config) {
              config = this.printers[i].config;
            }
            data.push(
              {
                printerId: this.printers[i].printerId,
                name: name,
                config: config,
                selection: this.printers[i].selection || this.layoutLevels[0].value,
                printerType: this.printers[i].printerType
              }
            );
          }

          if (this.currentTicketConfig.id) {
            model.id = this.currentTicketConfig.id;
          }
          model.printerConfigs = data;
          r = (angular.extend(this.currentTicketConfig, model));

        }

        return r;
      },

      onTemplatesCreateSchedulesCreateControllerSave: function(e, data) {
        var self = $scope.templatesCreateSchedulesCreateTickets,
          processed = self.marshall(),
          model = angular.toJson(processed),
          templateTicketConfig = angular.toJson(TemplatesService.getScheduleTicketConfig(self.schedule));

        if (model !== templateTicketConfig) {
          console.log('TemplatesCreateSchedulesCreateTicketsController::onTemplatesCreateSchedulesCreateControllerSave');
          TemplatesService.setScheduleTicketConfig(self.schedule, processed);
        }
      },

      onTemplatesServiceUpdate: function(e, data) {
        var self = $scope.templatesCreateSchedulesCreateTickets,
            ticketLayout;

        self.template = TemplatesService.getModel();

        // Next Tick
        $timeout(function() {

          if (self.schedule && TemplatesService.hasScheduleTicketConfig(self.schedule)) {
            self.currentTicketConfig = TemplatesService.getScheduleTicketConfig(this.schedule);
            if (!self.isCustomizedLayout()) {
              ticketLayout = self.findTicketConfig(self.currentTicketConfig.id);

              if (ticketLayout) {
                self.currentTicketConfig = self.ticketConfigs[ticketLayout.index];
              }
            }
            self.adjustLayoutSelectionName();
          }
        }, 0);
      }

    };

    $scope.templatesCreateSchedulesCreateTickets.init();

}]);